// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"cf731b76d6a2202ce412","303":"36f6eb03d37bf7bbd41b","495":"5bccc734c43b7715387b"}[chunkId] + ".js";
};